import { baseUrl } from '@fs/zion-config'

const relativesConfig = {
  eventIds: {
    integration: '92a0d86b-2b75-4b04-bb75-d622eeebbe55',
    beta: '8ceedfe4-9720-4292-be42-72f9e1da842d',
    prod: '902d49a6-414c-49ad-8370-4129535e9e83',
  },
}
relativesConfig.previewUrl = `${baseUrl}/en/connect/${relativesConfig.eventIds.prod}`

export default relativesConfig
